<template>
    <div class="epwin-system-types-list-item" :class="{ '_active' : userHasEpwinSystemType }" v-if="!edit_mode">
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Thank you for your interest</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        Your enquiry will be sent to our team who will aim to respond within 48 hours, you will be sent a notification when you receive a reply.
                    </div>
                    <div class="mb-6">
                        If you would like to provide some more information you can edit the message below.
                    </div>
                    <strong class="block pl-2 pb-1">Your Message</strong>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
        <div class="box">
            <div class="box-content">
                <div>
                    <div class="system-type-logo">
                        <img :src="`${$aws_bucket_url}${epwinSystemType.logo_url}`">
                    </div>
                    <div class="system-type-title">
                        {{ epwinSystemType.label }}
                    </div>
                    <template v-if="!logged_in_user.isStaff">
                        <div v-if="userHasEpwinSystemType" class="system-type-status">
                            <div class="status-circle _active"></div>
                            Actively<template v-if="logged_in_user.isInstaller">Installing</template> <template v-if="logged_in_user.isFabricator || logged_in_user.isTrial">Fabricating</template> <template v-if="logged_in_user.isTradeCounter">Providing</template> <template v-if="logged_in_user.isOther">Using</template> <template v-if="logged_in_user.isBuilder">Using</template>
                        </div>
                        <div v-else class="system-type-status">
                            <div class="status-circle"></div>
                            Not <template v-if="logged_in_user.isInstaller">Installing</template> <template v-if="logged_in_user.isFabricator || logged_in_user.isTrial">Fabricating</template> <template v-if="logged_in_user.isTradeCounter">Providing</template> <template v-if="logged_in_user.isOther">Using</template> <template v-if="logged_in_user.isBuilder">Using</template>
                        </div>
                    </template>
                    <div class="system-type-short-description">
                        {{ epwinSystemType.short_description }}
                    </div>
                    <div class="system-type-description">
                        {{ epwinSystemType.description }}
                    </div>
                </div>
                <template v-if="logged_in_user.isAdmin">
                    <div class="flex pt-3 mt-a">
                        <div class="flex flex-col justify-around">
                            <a class="txt-danger" href="#!">
                                <i class="fa fa-trash"></i>
                            </a>
                        </div>
                        <div class="ml-3">
                            <a class="btn-primary" @click.stop="edit_mode = true">
                                Edit
                            </a>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="flex pt-3 mt-a">
                        <div class="flex flex-col justify-around">
                            <a class="txt-secondary" :href="epwinSystemType.learn_more_url" target="_blank">
                                <strong>Learn More</strong>
                            </a>
                        </div>
                        <div class="ml-3" v-if="!userHasEpwinSystemType && logged_in_user.isCustomer">
                            <a class="btn-primary" @click.prevent="enquiry_box_open = true">
                                Make Enquiry
                            </a>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
    <div class="epwin-system-types-list-item" v-else>
        <div class="box">
            <div class="box-content">
                <label>
                    <form :action="`${$aws_upload_url}`" method="post"
                          enctype="multipart/form-data" class="mt-3" id="amazon_form">
                        <input type="hidden" name="policy" :value="aws_policy">
                        <input type="hidden" name="x-amz-algorithm" value="AWS4-HMAC-SHA256">
                        <input type="hidden" name="x-amz-credential" :value="aws_credential">
                        <input type="hidden" name="x-amz-date" :value="aws_date">
                        <input type="hidden" name="x-amz-signature" :value="aws_signature">
                        <input type="hidden" name="acl" value="private">
                        <input type="hidden" name="success_action_redirect" value="/systems">
                        <input type="hidden" name="Content-Type" v-model="filetype">
                        <input type="hidden" name="key" v-model="filename">
                        <input class="hide" type="file" name="file" @change="fileChanged($event)">
                    </form>
                    <div class="system-type-logo">
                        <img :src="`${$aws_bucket_url}${epwinSystemType.logo_url}`">
                    </div>
                    <div class="txt-sm align-center pb-3 pt-1">
                        Upload New Logo <i class="fal fa-upload"></i>
                    </div>
                </label>
                <input type="hidden" :value="csrfToken" name="_token">
                <input type="hidden" name="epwin_system_type_id" v-model="epwinSystemType.id">
                <div class="form-group">
                    <label>Title</label>
                    <input type="text" v-model="epwinSystemType.label" name="label" class="form-control">
                </div>
                <div class="form-group">
                    <label>Short Description</label>
                    <input type="text" v-model="epwinSystemType.short_description" name="label" class="form-control">
                </div>
                <div class="form-group">
                    <label> Description </label>
                    <textarea name="description" class="form-control" rows="8"
                              v-model="epwinSystemType.description"></textarea>
                </div>
                <div class="form-group">
                    <label> Learn More URL </label>
                    <input type="text" v-model="epwinSystemType.learn_more_url" name="learn_more_url"
                           class="form-control">
                </div>
                <div class="flex mt-3">
                    <div class="flex flex-col justify-around">
                        <a class="txt-danger" href="#!">
                            <i class="fa fa-trash"></i>
                        </a>
                    </div>
                    <div class="ml-3">
                        <a class="btn-default" @click.stop="edit_mode = false">
                            Cancel
                        </a>
                    </div>
                    <div class="ml-3">
                        <button class="btn-primary" @click.prevent="save()">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        'aws_policy': {
            required: true,
        },
        'aws_credential': {
            required: true,
        },
        'aws_date': {
            required: true,
        },
        'aws_signature': {
            required: true,
        },
        'logged_in_user': {
            required: true,
        },
        'epwinSystemType': {
            required: true,
        },
        'userHasEpwinSystemType': {
            required: true,
            default: false,
        },
    },
    data() {
        return {
            edit_mode: false,
            csrfToken: document.querySelector('meta[name="csrf-token"]')
                .getAttribute('content'),
            filename: '',
            filetype: '',
            enquiry_box_open: false,
            enquiry_message: `I am interested in some more information about ${this.epwinSystemType.label} , thank you.`,
            sending: false,
        };
    },
    methods: {
        fileChanged(event) {
            const extension = event.target.files[0].name.replace(/^.*\./, '');
            const filename = 'system_logos/' + Date.now();
            this.filename = filename + '.' + extension;
            this.filetype = event.target.files[0].type;
        },
        save() {

            const validationErrors = Validate({
                label: this.epwinSystemType.label,
                description: this.epwinSystemType.description,
                learn_more_url: this.epwinSystemType.learn_more_url,
            }, {
                label: {
                    presence: {
                        allowEmpty: false,
                    },
                },
                description: {
                    presence: {
                        allowEmpty: false,
                    },
                },
                learn_more_url: {
                    presence: {
                        allowEmpty: false,
                    },
                },
            });

            if (validationErrors) {
                Swal.fire({
                    title: 'Unable to update system',
                    icon: 'error',
                    html: `<div class="mb-3">${Object.values(validationErrors).join('</div><div class="mb-3">')}</div>`,
                });
                return;
            }

            axios.post('/saveSystemType', {
                epwinSystemType: this.epwinSystemType,
                newLogoUrl: this.filename,
            }).then((response) => {
                if(this.filename !== '') {
                    const form_data = new FormData(document.querySelector('#amazon_form'))
                    axios({
                        method: 'post',
                        url: this.$aws_upload_url,
                        data: form_data,
                        headers: { 'Content-Type': 'multipart/form-data' }
                    }).then(() => {
                        Swal.fire({
                            title: 'System Updated',
                            icon: 'success',
                            text: ''
                        });
                        this.edit_mode = false;
                    });
                } else {
                    Swal.fire({
                        title: 'System Updated',
                        icon: 'success',
                        text: ''
                    });
                    this.edit_mode = false;
                }
            });
        },
        sendEnquiry() {
            this.enquiry_box_open = false;
            this.sending = true;
            axios.post('/enquiry/send', {
                'enquiry_type_id': 6,
                'message': this.enquiry_message,
            }).then((response) => {

              gtag('event', 'enquiry_made', {
                'event_category': 'enquiries',
                'event_label': 'System type enquiry',
                'value': 'System type enquiry',
              });

                this.sending = false;
                Swal.fire({
                    title: 'Enquiry Sent',
                    icon: 'success',
                    text: 'Your Enquiry has been sent, you will be sent a notification when you receive a reply.'
                });
            });
        },
    },
};
</script>
